import type { OrderClaimDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useDateFormat } from "Infrastructure/Utilities/dateFormat";
import { UpdateClaimForm } from "Order/Modules/Claim/Components/Form/UpdateClaimForm";
import { claimStatusChipColor } from "Order/Modules/Claim/Helpers/UI/statusColors";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Chip, Stack } from "@mui/material";

const claimResource = Resources.base.claim;

type UpdateClaimCardWidgetProps = {
	claim: OrderClaimDetailResponseDto;
	orderId?: number;
	isLoading?: boolean;
};

export function UpdateClaimCardWidget({
	claim,
	orderId,
	isLoading,
}: UpdateClaimCardWidgetProps) {
	const { t } = useResource();
	const { formatDate } = useDateFormat();

	return (
		<BaseCard
			isLoading={isLoading}
			title={
				<Stack
					direction="row"
					gap={1}
					alignItems="center"
					justifyContent="space-between"
				>
					{t(claimResource.claimShared.editClaimHeading)}
					<Stack direction="row" gap={1}>
						<Chip
							label={`${t(claimResource.claimSelectOptions.claimStatus[claim.status])}`}
							color={claimStatusChipColor[claim.status]}
							size="small"
							variant="outlined"
						/>
						<Chip
							label={`${t(claimResource.claimShared.created)} ${formatDate(claim.dateCreated)}`}
							color="info"
							size="small"
						/>
					</Stack>
				</Stack>
			}
		>
			<UpdateClaimForm claim={claim} orderId={orderId} />
		</BaseCard>
	);
}
